import {createSelector} from 'reselect';
import props from './props';

export default createSelector(
    props.app.initialized,
    props.app.remote_details,
    props.user.loaded,
    props.games.loaded,
    props.vip.levels_loaded,
    props.app.notifications.initialized,
    props.user.isAuth,
    props.user.user,
    props.user.welcome_bonus_details,
    props.modals.modal,
    props.modals_action.active,
    props.tournaments.tournament_timestamp,
    props.app.affiliate_bonus,
    props.app.referral_bonus,
    props.app.isMobile,
    props.app.snowfall,
    props.modules.loaded,
    (initialized, remote_details, user, games, vip_levels, notifications, isAuth, user_data, welcome_bonus_details, active_modal, active_action_modals, tournaments_loaded, affiliate_bonus, referral_bonus, is_mobile, snowfall, modules_loaded) => {
        return { 
            loaded: initialized && user && games && vip_levels && notifications && (tournaments_loaded !== null) && modules_loaded,
            initialized,
            remote_details,
            user,
            modules_loaded,
            welcome_bonus_details,
            games,
            vip_levels,
            notifications,
            isAuth,
            user_data,
            modal_opened: active_modal || active_action_modals.length > 0,
            tournaments_loaded: tournaments_loaded !== null,
            is_mobile,
            snowfall
        }
    }
)